import { IAccount, IResource } from "./account.types";
import { IRole } from "./user.types";

/**
 * User interface.
 */
export interface IUser {
    accounts: IAccount[];
    name?: string;
    role: IRole[];
    roles?: any;
    email?: string;
    _id: string;
    isActive: boolean;
    isDefaultPassword: boolean;
    isEmailVerified: boolean;
    profilePic: string;
    status: string;
    auth?: any;
    isEmployee?: boolean;
    employeeId?: string;
}

/**
 * Interface for login api response.
 */
export interface ILoginResponse {
    token: string;
    user: IUser;
    selectedAccountId: string;
};

/**
 * Interface for login api request.
 */
export interface ILoginRequest {
    email: string;
    password: string;
    otp: string;
};

/**
 * Interface for error.
 */
export interface IError {
    message: string;
};

export type TResourcePartial = Omit<IResource, '_id' | 'action'>;

export type TSidebarCategories = Record<string, TResourcePartial[]>;

/**
 * Interface for User State.
 */
export interface IAuthState {
    user: IUser;
    isLoggedIn: boolean;
    isLoading: boolean;
    isError: boolean;
    errorMessage: string;
    permissions: string[] | undefined;
    sidebarCategories: TSidebarCategories;
    // Raw new-system grants (module/sub-module access, locations, enforcement flag,
    // isAccountOwner). Used to hide ungranted modules and gate routes.
    modulePermissions?: any;
    switchingAccount: boolean;
    selectedAccount: IAccount;
    isSelfRegistered: boolean;
}

export const enum PermissionsEnum {
    Account_Create = "Account_Create",
    Account_Update = "Account_Update",
    Account_View = "Account_View",
    Account_Delete = "Account_Delete",
    Users_Create = "Users_Create",
    Users_Update = "Users_Update",
    Users_View = "Users_View",
    Users_Delete = "Users_Delete",
    // Invoice_Create = "Invoice_Create",
    // Invoice_Update = "Invoice_Update",

    // CRM
    Lead_View = "Lead_View",
    Lead_Create = "Lead_Create",
    Lead_Update = "Lead_Update",
    Lead_Delete = "Lead_Delete",
    Lead_Convert = "Lead_Convert",
    Campaign_View = "Campaign_View",
    Campaign_Create = "Campaign_Create",
    Campaign_Update = "Campaign_Update",
    Campaign_Delete = "Campaign_Delete",
    TelecallingLog_View = "TelecallingLog_View",
    TelecallingLog_Create = "TelecallingLog_Create",
    TelecallingLog_Update = "TelecallingLog_Update",
    TelecallingLog_Delete = "TelecallingLog_Delete",
    FollowUp_View = "FollowUp_View",
    FollowUp_Create = "FollowUp_Create",
    FollowUp_Update = "FollowUp_Update",
    FollowUp_Delete = "FollowUp_Delete",
    WebhookIngestion_View = "WebhookIngestion_View",
    WebhookIngestion_Update = "WebhookIngestion_Update",
}

/**
 * Interface for user update api response;
 */

export interface IUserProfilePicUpdatePayload {
    profilePic: FormData;
    id: string;
};

export interface IProfilePicUpdateResponse {
    message: string;
    user: IUser;
}

/**
 * Interface for switch account async thunk arguments.
 */
export interface ISwitchAccount {
    accountId: string;
    userId: string;
}

/**
 * Interface for register api request.
 */
export interface IRegisterRequest {
    name: string;
    email: string;
    phone: string;
    password: string;
};

/**
 * Interface for register api response.
 */
export interface IRegisterResponse {
    user: IUser;
};

/**
 * Interface for register api request.
 */
export interface IUserInviteToken {
    token: string;
};

export interface IUserEmailSearch {
    email: string;
};